import gsap from 'gsap';

const SlideInitial = (element) => {
  gsap.set(element.querySelector('div'), { yPercent: -100 });
};

export default SlideInitial;
